import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insideImages, PURCHASE_ANCHOR } from '../data/content';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(insideImages.length - 1, i));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      setIndex(Math.round(track.scrollLeft / track.clientWidth));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-white px-4 py-5 sm:px-6" data-id="element-87" data-mp="1dwequy1cyxm1">
      <div className="mx-auto max-w-3xl" data-id="element-88" data-mp="1dz9a4m8mycdv">
        <h2 className="text-center font-heading text-xl font-extrabold uppercase text-deep sm:text-3xl" data-id="element-89" data-mp="a1whg48ebc27">
          Look inside
        </h2>
        <p className="mt-0.5 text-center font-heading text-[0.86rem] font-semibold text-ink sm:text-base" data-id="element-90" data-mp="635jxw00psek">
          Discover What’s Inside OPHTHALMOLOGY VISUAL ATLAS™
        </p>
        <p className="mx-auto mt-1 max-w-xl text-center text-[0.75rem] leading-snug text-muted sm:text-sm" data-id="element-91" data-mp="f2ai317o3jq7">
          Explore OCT patterns, fundus comparisons, retinal findings, optic
          nerve references, RNFL maps, visual field patterns, corneal imaging,
          annotated comparisons and multimodal resources included throughout
          the complete system.
        </p>

        <div className="relative mt-3" data-id="element-92" data-mp="3sfm7x7jxhcfs">
          <div ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory overflow-x-auto scroll-smooth rounded-xl" aria-label="Carousel of pages inside OPHTHALMOLOGY VISUAL ATLAS" data-id="element-93" data-mp="3sekp2gwo7lni">
            {insideImages.map((img, i) => <div key={img.src} className="w-full shrink-0 snap-center px-0.5" data-id="element-94" data-mp="13olec7ohcc1l" data-mpi={i}>
                <a href={PURCHASE_ANCHOR} className="block" data-id="element-95" data-mp="18mn75kbpjpq9">
                  <img src={img.src} alt={`${img.caption} — page inside OPHTHALMOLOGY VISUAL ATLAS™`} loading={i === 0 ? 'eager' : 'lazy'} className="w-full rounded-xl border border-clinical/20 bg-ice object-contain shadow-md" data-id="element-96" data-mp="1dewquim8btk3" />
                </a>
              </div>)}
          </div>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1 top-1/2 -translate-y-1/2 rounded-full border border-clinical/25 bg-white/95 p-2 text-deep shadow-md transition-opacity duration-150 ease-out disabled:opacity-30" data-id="element-97" data-mp="tqxgh8vkuof7">
            <ChevronLeftIcon className="h-5 w-5" data-id="element-98" data-mp="2a6qps6wf7ce5" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === insideImages.length - 1} aria-label="Next page" className="absolute right-1 top-1/2 -translate-y-1/2 rounded-full border border-clinical/25 bg-white/95 p-2 text-deep shadow-md transition-opacity duration-150 ease-out disabled:opacity-30" data-id="element-99" data-mp="2k8cj937bsylw">
            <ChevronRightIcon className="h-5 w-5" data-id="element-100" data-mp="21jxqaadg7aig" />
          </button>
        </div>

        <p className="mt-1.5 text-center font-heading text-[0.72rem] font-bold uppercase tracking-wide text-deep sm:text-sm" data-id="element-101" data-mp="1wii6eln0ba1n">
          {index + 1} / {insideImages.length} — {insideImages[index].caption}
        </p>

        <div className="mt-1.5 flex justify-center gap-2" data-id="element-102" data-mp="1nk69y2zgli1a">
          {insideImages.map((img, i) => <button key={img.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1}`} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 ease-out ${i === index ? 'w-6 bg-turq' : 'w-2.5 bg-clinical/25'}`} data-id="element-103" data-mp="3lxevoerpzxav" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}